import React, { useEffect } from 'react';
import './tramite.css';
import { tramites } from '../../json/tramites';

const iconos = [
  'fa-solid fa-clipboard-check',
  'fa-solid fa-scale-balanced',
  'fa-solid fa-people-group',
  'fa-solid fa-file-magnifying-glass',
];

const Tramites = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="tramites-page">
      <div className="tramites-container">

        {/* ENCABEZADO */}
        <div className="tramites-header">
          <h1>Trámites y Servicios</h1>

          <div className="tramites-title-line">
            <span></span>
          </div>

          <p>
            Selecciona la Dirección General para consultar sus trámites y servicios.
          </p>
        </div>

        {/* TARJETAS PRINCIPALES */}
        <div className="tramites-grid">
          {tramites.map((tramite, index1) => (
            <div className="tramites-item" key={index1}>

              <button
                className="tramites-card"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#tramite-${index1}`}
                aria-expanded="false"
                aria-controls={`tramite-${index1}`}
              >
                <div
                  className={`tramites-icon ${
                    index1 % 2 === 0
                      ? 'tramites-icon-gold'
                      : 'tramites-icon-wine'
                  }`}
                >
                  <i
                    className={
                      iconos[index1] || 'fa-solid fa-folder-open'
                    }
                  ></i>
                </div>

                <div className="tramites-card-title">
                  {tramite.anio}
                </div>

                <div className="tramites-arrow">
                  <i className="fa-solid fa-arrow-right"></i>
                </div>
              </button>

              {/* CONTENIDO DE LA DIRECCIÓN */}
              <div
                className="collapse tramites-collapse"
                id={`tramite-${index1}`}
              >
                <div className="tramites-collapse-inner">
                  {tramite.tramitesLista.map((lista, index2) => (
                    <div
                      className="tramites-subitem"
                      key={`${index1}-${index2}`}
                    >
                      <button
                        className="tramites-subitem-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#lista-${index1}-${index2}`}
                        aria-expanded="false"
                        aria-controls={`lista-${index1}-${index2}`}
                      >
                        <span>{lista.nombre}</span>

                        <i className="fa-solid fa-chevron-down"></i>
                      </button>

                      <div
                        className="collapse"
                        id={`lista-${index1}-${index2}`}
                      >
                        <div className="tramites-links">
                          {lista.contenidoTramite.map(
                            (contenido, index3) =>
                              contenido.url && (
                                <a
                                  key={`${index1}-${index2}-${index3}`}
                                  href={contenido.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="tramites-link"
                                >
                                  <span>
                                    <i className="fa-regular fa-file-lines"></i>
                                    {contenido.nombre}
                                  </span>

                                  <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                              )
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </main>
  );
};

export default Tramites;